import type { FC } from 'react';
import { Button, ContainedList, ContainedListItem, HeaderPanel, Tag } from '@carbon/react';
import { Logout } from '@carbon/icons-react';

import type { EstadoDoPlano } from '../../logica/casca/useMenuDaConta';
import styles from './Casca.module.scss';

// A CONTA — o painel da direita do avatar: quem está logado e o plano, os destinos da conta, a
// administração (para quem tem acesso) e sair. Cada grupo é uma `ContainedList` com o rótulo do
// próprio Carbon. Painel da direita não tem item selecionado.

export interface DestinoDoPainel {
  chave: string;
  rotulo: string;
  caminho: string;
}

export interface ContaDoPainel {
  nome?: string;
  email?: string;
  plano: EstadoDoPlano;
  daConta: DestinoDoPainel[];
  doAdmin: DestinoDoPainel[];
  abrir: (caminho: string) => void;
  sair: () => void;
}

const ROTULO_DO_PLANO: Record<Exclude<EstadoDoPlano, null>, { texto: string; tipo: 'blue' | 'warm-gray' | 'gray' }> = {
  pro: { texto: 'Pro', tipo: 'blue' },
  pendente: { texto: 'Pagamento em confirmação', tipo: 'warm-gray' },
  free: { texto: 'Gratuito', tipo: 'gray' },
};

export const PainelDaConta: FC<{
  aberto: boolean;
  conta: ContaDoPainel;
  aoEscolher: () => void;
}> = ({ aberto, conta, aoEscolher }) => {
  const grupo = (rotulo: string, destinos: DestinoDoPainel[]) => (
    <ContainedList label={rotulo} kind='disclosed'>
      {destinos.map((d) => (
        <ContainedListItem key={d.chave} onClick={() => { aoEscolher(); conta.abrir(d.caminho); }}>
          {d.rotulo}
        </ContainedListItem>
      ))}
    </ContainedList>
  );

  return (
    <HeaderPanel expanded={aberto} aria-label='Sua conta' className={styles.painel}>
      {aberto && (
        <>
          <div className={styles.quem}>
            {conta.nome && <p className={styles.quemNome}>{conta.nome}</p>}
            {conta.email && <p className={styles.quemEmail}>{conta.email}</p>}
            {conta.plano && (
              <Tag size='sm' type={ROTULO_DO_PLANO[conta.plano].tipo}>{ROTULO_DO_PLANO[conta.plano].texto}</Tag>
            )}
          </div>
          {grupo('Conta', conta.daConta)}
          {conta.doAdmin.length > 0 && grupo('Administração', conta.doAdmin)}
          <div className={styles.acaoDoPainel}>
            <Button kind='ghost' size='md' renderIcon={Logout} onClick={() => { aoEscolher(); conta.sair(); }}>
              Sair da conta
            </Button>
          </div>
        </>
      )}
    </HeaderPanel>
  );
};
